import React, { Component } from 'react';
import Project from './project.jsx'
import Timercounter from './timer.jsx'

class Timercomponent extends Component {
  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = {title:''}
  }

  handleSubmit(e){
    e.preventDefault()
    this.props.setActiveRecordTitle(this.state.title)
  }

  handleChange(e){
    this.setState({title:e.target.value})
  }

  componentWillMount = ()=>{
    this.setState({title:this.props.timer.active_record.name})
  }

  componentWillReceiveProps = (newProps, newState)=>{
    this.setState({title:newProps.timer.active_record.name})
  }

  render() {
    const {timer} = this.props || {}
    return (
      <div className='headbar-in'>
        <form onSubmit={this.handleSubmit}>
          <input type="text" placeholder="در حال انجام چه کاری هستید؟" value={this.state.title || ''} onChange={this.handleChange} onBlur={this.handleSubmit} className="record-dsc-input"/>
        </form>
        <Project active={true} selected={timer.active_record}></Project>
        <div id='timer-start-btn'>
          <Timercounter updateActiveRecordStart={this.props.updateActiveRecordStart} active={timer.active_record}/>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Timercomponent;
